<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onReset()">
            <img src="assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "control_social_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

@let itemField = form().socialAt(index());

@if (itemField) {
    @let itemValue = itemField().value();

    <div class="panel-options-body">
        <div class="form">
            <div class="form-group mb-20" [class.has-error]="saveDisablePredicate">
                <div class="input-group">
                    <div class="input-group-btn" dropdown>
                        <button dropdownToggle type="button" class="btn btn-default type-dropdown-toggle">
                            <img
                                class="element-icon mr-10"
                                src="./assets/img/websites/social-icons/logos/{{ itemValue.socialNetwork }}-logos.svg"
                                alt="facebook"
                            />
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu dropdown-overflow-wrapper" *dropdownMenu>
                            @for (icon of ICON_NAMES; track icon) {
                                <li [class.selected]="icon === itemValue.socialNetwork" (click)="setIconName(icon)">
                                    <a>
                                        <span class="dropdown-icon mr-10">
                                            <img
                                                src="./assets/img/websites/social-icons/logos/{{ icon }}-logos.svg"
                                                alt="facebook"
                                            />
                                        </span>
                                        {{ getSocialNetworkName(icon) }}
                                    </a>
                                </li>
                            }
                        </ul>
                    </div>
                    <input class="form-control" [formField]="itemField.name" />
                </div>
                @if (saveDisablePredicate) {
                    <span class="help-block small">
                        {{ "control_errors_required" | translate }}
                    </span>
                }
            </div>

            <div class="form-group mb-10">
                <label>{{ "control_link" | translate }}</label>
                <input
                    class="form-control"
                    [placeholder]="getPlaceholder(itemValue.socialNetwork)"
                    [formField]="itemField.link"
                />
            </div>

            @if (itemValue.socialNetwork === ESocialNetworks.telegram) {
                <div class="form-group mb-0">
                    <label class="checkbox-inline">
                        <input
                            type="checkbox"
                            [checked]="itemValue.preventLinkConverting"
                            (change)="togglePreventLinkConverting($any($event.target).checked)"
                        />
                        {{ "prevent_link_wrapping" | translate }}
                    </label>
                </div>
            }
        </div>
    </div>
}

<web-settings-footer [isSaveDisabled]="saveDisablePredicate" (saveEvent)="onSave()" (cancelEvent)="onReset()" />
